import { render, staticRenderFns } from "./Slideshow.vue?vue&type=template&id=13e087d2&scoped=true&"
import script from "./Slideshow.vue?vue&type=script&lang=ts&"
export * from "./Slideshow.vue?vue&type=script&lang=ts&"
import style0 from "./Slideshow.vue?vue&type=style&index=0&id=13e087d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e087d2",
  null
  
)

export default component.exports